<template>
    <div>
        <b-card title="" border-variant="primary">
            <div class="d-flex align-items-center justify-content-between mb-1">
                <h5 class="mb-0">Informe identificación Riesgos SPM EE</h5>
                <b-button v-if="can('delete_gei_children_identification_risk')"
                    variant="outline-success"
                    @click="addRow"
                    :disabled="hasMatchingDocument"
                >
                    <feather-icon
                        icon="PlusIcon"
                        size="16"
                        variant="success"
                        class="cursor-pointer "
                    />
                </b-button>
            </div>

            <form-base-document
                :documents-state-data="documents_identification_risk_e_e"
                :documents-columns="columns"
                :documents-route="documents_by_route_identification_risk_e_e"
                :context="'identification-risk-ee'"
                :create-permission="can('create_gei_children_identification_risk')"
                :delete-permission="can('delete_gei_children_identification_risk')"
            />

        </b-card>

    </div>
</template>

<script>
import {BCard, BButton} from 'bootstrap-vue'
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"

import formBaseDocument from "@/views/gei/children_installations/form/tabRisks/components/base/formBaseDocument"
import {mapFields} from "vuex-map-fields"

export default {
    name: "FormContractProviderDocuments",
    components: {
        BButton,
        BCard,
        formBaseDocument

    },
    data() {
        return {
            columns: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'effective_date', label: 'Fecha Realización', sortable: false},
                {key: 'technician', label: 'Técnico', sortable: false},
                {key: 'request_date', label: 'Fecha Solucitud SPM', sortable: false},
                {key: 'observations', label: 'Observaciones', sortable: false},
            ],
        }
    },
    computed: {
        ...mapState('childrenInstallation', []),
        ...mapState('childrenInstallationDocuments', []),
        ...mapFields({
            documents_identification_risk_e_e: 'childrenInstallationDocuments.documents_identification_risk_e_e',
            documents_by_route_identification_risk_e_e: 'childrenInstallationDocuments.documents_by_route_identification_risk_e_e',
            child_installation: 'childrenInstallation.child_installation',
        }),
        hasMatchingDocument() {
          return this.documents_identification_risk_e_e.some(doc => doc.empty_row === true)
        }
    },
    mounted() {
       this.context = 'identification-risk-ee'
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        addRow() {
            const newRow = {
                empty_row: true,
                effective_date: null,
                technician: null,
                request_date: null,
                observations: null,
                route: this.child_installation.master_installation.installation_code +"/"+ this.child_installation.gei_code + "/IDENTIFICACION_RIESGOS/EE",
                options: null,
                children_installation_id: this.child_installation.id,
            }

            this.documents_identification_risk_e_e.unshift(newRow)
            this.documents_identification_risk_e_e.editedRow = newRow
        },
    }

}
</script>